import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';
import { AuthenticationError } from '@atlassian/jira-standard-errors/src/common/utils/authentication-error/index.tsx';
import { ADDON_TYPE } from '../../constants.tsx';
import type { AddonItem, FetchAddonContext } from '../../types.tsx';

const handleError = (error: AuthenticationError | Error) => {
	// Temp
	throw error;
};

export const fetchAddonItems = async (context?: FetchAddonContext): Promise<AddonItem[]> => {
	const params = getContextParams(context);
	const url = `/rest/navigation/3/global/addons${params ? `?${params}` : ''}`;
	try {
		const response = await fetch(url, getDefaultOptions(url));
		if (!response.ok) {
			const errorCode = response.status;
			if (errorCode === 401) {
				return handleError(new AuthenticationError(`${errorCode}`));
			}
			return handleError(new FetchError(errorCode, response.statusText));
		}
		const addonsItems = await response.json();
		// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
		return addonsItems.map((item) => ({
			id: item.id,
			title: item.name,
			avatarUrl: item.iconUrl,
			type: ADDON_TYPE,
			url: item.url,
			className: item.styleClass,
		}));
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// network issue
		return handleError(error);
	}
};

function getContextParams(context?: FetchAddonContext) {
	const filteredParams: Record<string, string> = Object.fromEntries(
		Object.entries(context || {}).filter(([, value]) => !!value),
	);
	return new URLSearchParams(filteredParams).toString();
}
